var map = {
	"./album.png": 7908,
	"./artifact.png": 751,
	"./boards.png": 1838,
	"./book.png": 5074,
	"./map_arrow_bottom.png": 6863,
	"./map_arrow_mid.png": 5758,
	"./map_arrow_top.png": 4917,
	"./site.png": 3780,
	"./sussex.png": 5464,
	"./throwback.png": 452,
	"./window.png": 3181,
	"./wing.png": 5068
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9922;